import { apiQuery, atsApiQuery } from '../';

export const api = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getOpenJobs: builder.query({
        transformResponse: (response) => response.data,
        query: () => {
          return {
            method: 'get',
            url: '/ats_jobs?only=open',
          };
        },
      }),

      getJobs: builder.query({
        transformResponse: (response) => response.data,
        query: () => {
          return {
            method: 'get',
            url: '/reports/filter/ats_job',
          };
        },
      }),

      getDepartments: builder.query({
        transformResponse: (response) => response.data,
        query: () => {
          return {
            method: 'get',
            url: '/reports/filter/ats_department',
          };
        },
      }),

      getATSJobCandidates: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ outreachId, jobId }) => {
          return {
            method: 'get',
            url: `outreaches/${outreachId}/existing_ats_job_candidates?ats_job_id=${jobId}`,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const atsApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getOpenKulaATSJobs: builder.query({
        transformResponse: (response) => response.data,
        query: () => {
          return {
            method: 'get',
            url: '/ats_jobs/list?filter_by[job_statuses][]=published',
          };
        },
      }),
      getATSRejectionList: builder.query({
        transformResponse: (response) => response.data,
        query: () => {
          return {
            method: 'get',
            url: 'ats_rejection_reasons',
          };
        },
        keepUnusedDataFor: 0,
      }),
      getATSStage: builder.mutation({
        transformResponse: (response) => response.data,
        query: (jobId) => {
          return {
            method: 'get',
            url: `ats_jobs/${jobId}/ats_job_stages/list`,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetOpenJobsQuery,
  useGetJobsQuery,
  useGetDepartmentsQuery,
  useGetATSJobCandidatesMutation,
} = api;

export const {
  useGetOpenKulaATSJobsQuery,
  useGetATSRejectionListQuery,
  useGetATSStageMutation,
} = atsApi;
